<template>
  <div class="user">
    <div class="photo">
      <img :src="userAvatar" alt="avatar"/>
    </div>
    <div class="info">
      <a data-toggle="collapse" :aria-expanded="!isClosed" @click.stop="toggleMenu" href="javascript:;">
        <span>
          {{title}}
          <b class="caret"></b>
        </span>
      </a>
      <div class="clearfix"></div>
      <div>
        <el-collapse-transition>
          <ul class="nav" v-show="!isClosed">
            <slot>
              <li>
                <router-link class="profile-dropdown" to="/users/profile">
                  <span class="sidebar-mini">MP</span>
                  <span class="sidebar-normal">Mi Perfil</span>
                </router-link>
              </li>
              <!-- <li>
                <a class="profile-dropdown" href="#">
                  <span class="sidebar-mini">C</span>
                  <span class="sidebar-normal">Configuración</span>
                </a>
              </li> -->
            </slot>
          </ul>
        </el-collapse-transition>
      </div>
    </div>
  </div>
</template>
<script>
  import CollapseTransition from 'element-ui/lib/transitions/collapse-transition'

  export default {
    components: {
      [CollapseTransition.name]: CollapseTransition
    },
    props: {
      title: {
        type: String,
        default: 'Usuario'
      }
    },
    data () {
      return {
        isClosed: true,
        userAvatar: 'static/img/faces/' + JSON.parse(localStorage.getItem('user')).avatar
      }
    },
    methods: {
      toggleMenu () {
        this.isClosed = !this.isClosed
      }
    }
  }
</script>
<style>
  .collapsed {
    transition: opacity 1s;
  }
</style>
